import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation, Redirect } from 'react-router-dom';

import { isUserAuthenticated } from '@actions/selectors';
import urls from '@src/urls';

export default function AuthRedirect({ children }) {
  const isAuthenticated = useSelector(isUserAuthenticated);
  const location = useLocation();

  if (isAuthenticated === undefined) {
    return null;
  }

  return !isAuthenticated ? (
    <Redirect
      to={{ pathname: urls.unauthed.login(), search: location.search }}
    />
  ) : (
    children
  );
}
